"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _GenerateQrcode = _interopRequireDefault(require("../GenerateQrcode"));
var _teaComponent = require("@tencent/tea-component");
var _excluded = ["className", "style", "size", "caption", "visible", "activeName", "activeDate", "activeUrl", "activeCode", "onCopyClick", "children"];
var ShareActiveModal = function ShareActiveModal(props) {
  var className = props.className,
    style = props.style,
    size = props.size,
    caption = props.caption,
    visible = props.visible,
    activeName = props.activeName,
    activeDate = props.activeDate,
    activeUrl = props.activeUrl,
    activeCode = props.activeCode,
    onCopyClick = props.onCopyClick,
    children = props.children,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('share-active-modal');
  var classes = (0, _classnames.default)(prefixCls, className);
  return /*#__PURE__*/_react.default.createElement(_teaComponent.Modal, (0, _extends2.default)({
    size: size,
    caption: caption,
    visible: visible,
    className: classes
  }, extraProps), /*#__PURE__*/_react.default.createElement(_teaComponent.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "active-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "active-params"
  }, activeName && /*#__PURE__*/_react.default.createElement(_teaComponent.Popover, {
    placement: "bottom",
    overlay: /*#__PURE__*/_react.default.createElement(_teaComponent.DropdownBox, {
      style: {
        maxWidth: '230px'
      }
    }, /*#__PURE__*/_react.default.createElement(_teaComponent.Text, {
      theme: "text",
      className: "size-s"
    }, activeName))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "active-title"
  }, activeName)), activeDate && /*#__PURE__*/_react.default.createElement("div", {
    className: "active-date"
  }, activeDate)), /*#__PURE__*/_react.default.createElement("div", {
    className: "active-share"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "active-share__label"
  }, "\u6D3B\u52A8\u8BE6\u60C5\u9875\u94FE\u63A5\uFF0C\u53EF\u901A\u8FC7\u590D\u5236\u6B64\u9080\u8BF7\uFF1A"), /*#__PURE__*/_react.default.createElement("div", {
    className: "active-share__value"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "active-share__left"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "active-share__url"
  }, activeUrl), /*#__PURE__*/_react.default.createElement(_teaComponent.Button, {
    type: "primary",
    className: "active-share__btn  size-xs",
    onClick: function onClick() {
      onCopyClick ? onCopyClick() : undefined;
    }
  }, "\u590D\u5236")), /*#__PURE__*/_react.default.createElement("div", {
    className: "active-share__right"
  }, activeCode && /*#__PURE__*/_react.default.createElement("div", {
    className: "active-code"
  }, /*#__PURE__*/_react.default.createElement(_GenerateQrcode.default, activeCode)), /*#__PURE__*/_react.default.createElement(_teaComponent.Button, {
    className: "active-share__btn size-full-width",
    type: "primary",
    style: {
      pointerEvents: 'none'
    }
  }, "\u626B\u7801\u5206\u4EAB"))))), children));
};
var _default = ShareActiveModal;
exports.default = _default;